import React, { useState } from "react";
import axios from "axios";

const ClothSegmentation = () => {
  const [file, setFile] = useState(null);
  const [processedImage, setProcessedImage] = useState(null);
  const [loading, setLoading] = useState(false); // Yüklenme durumu

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Lütfen bir dosya seçin.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    setLoading(true); // Yüklenme durumunu başlat

    try {
      const response = await axios.post("https://semantic-segmentation-service-296705943739.us-central1.run.app/process/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        responseType: "blob", // Resmi binary olarak al
      });

      const imageURL = URL.createObjectURL(response.data);
      setProcessedImage(imageURL);
    } catch (error) {
      console.error("Hata:", error);
      alert("Resim yüklenirken hata oluştu.");
    } finally {
      setLoading(false); // Yüklenme durumunu sonlandır
    }
  };

  return (
    <div className="w-full mx-auto p-6 bg-white shadow-lg items-center rounded-lg">
      <h1 className="text-2xl font-bold mb-4 text-center">
        Test etmek için kıyafet içeren resim yükle
      </h1>
  

      <input type="file" accept="image/*" onChange={handleFileChange} className="mb-4" />
      <button
        onClick={handleUpload}
        className="bg-purple-500 text-white px-4 py-2 rounded hover:bg-opacity-[80%]"
        disabled={loading} // Yüklenirken butonu devre dışı bırak
      >
        {loading ? "Yükleniyor..." : "Yükle ve İşle"}
      </button>

      {loading && <p className="text-center mt-4">Lütfen bekleyin, resim işleniyor...</p>}

      {processedImage && (
        <div className="w-full mt-6">
          <h2 className="text-xl font-semibold mb-2 text-center">İşlenmiş Görüntü</h2>
          <img src={processedImage} alt="Processed Output" className="rounded-lg shadow-lg mx-auto" />
        </div>
      )}
    </div>
  );
};

export default ClothSegmentation;